import React from 'react'
import IconButton from '../../../components/common/form/button/IconButton'
import IconPencil from '../../../components/common/icon/IconPencil'
import IconTrash from '../../../components/common/icon/IconTrash'
import { ResourceList } from '../resource-list/ResourceList'
import { DeleteThemeModal } from '../delete-theme-modal/DeleteThemeModal'
import { EditThemeModal } from '../edit-theme-modal/EditThemeModal'
import { useModal } from 'front-end/src/app/hooks/useModal'
import { useRearrangeTopicsInThemeMutation } from 'front-end/src/pages/manage-workspace-page/resources-subpage/ManageTheme.codegen'

export const ManageTheme = ({
  theme,
  refetchWorkspace,
  topicToResourceListItemMapper,
  isAssigning,
  isRearrangeInProgress,
  DragHandle
}) => {
  const { open, currentModal } = useModal()
  const [reorderResourcesInGql] = useRearrangeTopicsInThemeMutation()

  const wrappedReorderResourcesInGql = React.useCallback(
    async (topicIds: number[]) => {
      await reorderResourcesInGql({
        variables: {
          topicIds,
          themeId: theme.id,
          workspaceId
        }
      })
    },
    [reorderResourcesInGql, theme.id]
  )

  const { workspace_id: workspaceId } = theme
  const resourcesList = React.useMemo(
    () =>
      theme.topics.map((topic) => {
        return topicToResourceListItemMapper(topic)
      }),
    [theme.topics, topicToResourceListItemMapper]
  )

  return (
    <div className="ManageWorkspacePage__theme">
      <div className="ManageWorkspacePage__themeHeader ThemeHeader">
        <h3>{theme.title}</h3>
        <div className="ManageWorkspacePage__theme-controls">
          <IconButton
            icon={<IconPencil />}
            hint="Edit"
            onClick={() =>
              open(EditThemeModal, {
                theme,
                workspaceId
              }).then(refetchWorkspace)
            }
          />

          <IconButton
            icon={<IconTrash />}
            hint="Delete"
            onClick={() =>
              open(DeleteThemeModal, { theme, workspaceId }).then(
                refetchWorkspace
              )
            }
          />
          {!isAssigning && !isRearrangeInProgress && <DragHandle />}
        </div>
      </div>
      <ResourceList
        resources={resourcesList}
        workspaceId={workspaceId}
        themeId={theme.id}
        showSelection={isAssigning}
        refetchTopics={refetchWorkspace}
        rearrangeResources={wrappedReorderResourcesInGql}
      />

      {currentModal}
    </div>
  )
}
